///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";

import messages from "../../helpers/messages";
import {
  resetSystemNotificationState,
  sendSystemNotification
} from "../../slices/notificationsSlice";
import Spinner from "../icons/Spinner";
import Alert from "../Alert";
import SystemErrorModal from "../SystemErrorModal";

export const SystemNotification = () => {
  const dispatch = useDispatch();
  const {
    systemNotification: { isSaving, isFailure, isSuccessfullySent }
  } = useSelector(state => state.notifications);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [validationMessage, setValidationMessage] = useState("");

  const handleEditorOnBlur = () => {
    if (
      draftToHtml(convertToRaw(editorState.getCurrentContent())).length > 2000
    ) {
      setValidationMessage(
        messages.systemNotificationValidationMessage.defaultMessage
      );
    }
  };

  const handleSendClick = () => {
    dispatch(
      sendSystemNotification(
        draftToHtml(convertToRaw(editorState.getCurrentContent()))
      )
    );
  };

  return (
    <>
      <Editor
        editorState={editorState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        onEditorStateChange={e => setEditorState(e)}
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "fontFamily",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "embedded",
            "image",
            "history"
          ]
        }}
        onBlur={handleEditorOnBlur}
        onFocus={() => setValidationMessage("")}
      />
      <span className="validation-message">{validationMessage}</span>
      <button
        className="my-24 mr-24 primary-button fr px-40"
        onClick={handleSendClick}
        data-testid="send"
        disabled={
          !editorState.getCurrentContent().hasText() || validationMessage
        }
      >
        {isSaving && (
          <Spinner
            className="spinner"
            fill="#ffffff"
            height="16px"
            width="16px"
          />
        )}
        {!isSaving && messages.send.defaultMessage}
      </button>
      <SystemErrorModal
        open={isFailure}
        handleTryAgain={handleSendClick}
        handleExit={() => dispatch(resetSystemNotificationState())}
        closeModal={() => dispatch(resetSystemNotificationState())}
      />
      <Alert
        title={messages.success.defaultMessage}
        message={messages.systemNotificationSentSuccessfully.defaultMessage}
        open={isSuccessfullySent}
        handleClose={() => {
          dispatch(resetSystemNotificationState());
          setEditorState(EditorState.createEmpty());
        }}
        large={true}
      />
    </>
  );
};

export default SystemNotification;
